import { useLanguageContext } from "../../../../context/LanguageContext";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import IconSelect from "../../../../components/select/main/icon/IconSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import Select from "../../../../components/select/main/Select";
import { StyledAltIconButton } from "../../../../styles/ButtonStyles";
import {
  StyledDataTableHeader,
  StyledDataTableWrapper,
  StyledHeader,
  StyledHeaderLeft,
  StyledHeaderRight,
  StyledTableWrapper,
} from "../../../../components/dataTable/main/DataTableStyles";

function PaxtonVisitorTypesView({
  availableVisitorTypes = [],
  visitorTypeLabels = {},
  configData,
  paxtonResources,
  onVisitorTypeAdd,
  onVisitorTypeChange,
  onVisitorTypeDelete,
}) {
  const { translate, translateEntity } = useLanguageContext();

  return (
    <StyledDataTableWrapper>
      <StyledDataTableHeader>
        <StyledHeaderLeft>
          <StyledHeader>
            {translate("eva.main.entities.visitor_types")}
          </StyledHeader>
        </StyledHeaderLeft>

        <StyledHeaderRight>
          <IconSelect
            options={availableVisitorTypes.map((visitorType) => ({
              value: visitorType.id,
              label: translateEntity(visitorType, "label"),
            }))}
            icon={() => <FontAwesomeIcon icon={faPlus} />}
            style={{ marginLeft: "auto" }}
            onChange={(value) => onVisitorTypeAdd(value)}
            disabled={availableVisitorTypes.length <= 0}
          />
        </StyledHeaderRight>
      </StyledDataTableHeader>

      <OverlayLoader groups="paxton_configs_page_fetch">
        <StyledTableWrapper>
          <table>
            <thead>
              <tr>
                <th style={{ width: "50%" }}>
                  {translate(
                    "eva.main.validation.attributes.visitor_types.*.visitor_type_id",
                  )}
                </th>

                <th style={{ width: "50%" }}>
                  {translate(
                    "eva.main.validation.attributes.visitor_types.*.access_level_id",
                  )}
                </th>

                <th style={{ width: 0 }}></th>
              </tr>
            </thead>

            <tbody>
              {configData?.visitor_types?.length === 0 && (
                <tr>
                  <td colSpan={3} style={{ textAlign: "center" }}>
                    {translate("eva.main.general.no_results")}
                  </td>
                </tr>
              )}

              {configData?.visitor_types?.map((configVisitorType) => (
                <tr key={configVisitorType.visitor_type_id}>
                  <td>
                    {visitorTypeLabels[configVisitorType.visitor_type_id] ??
                      "Unknown Visitor Type"}
                  </td>

                  <td>
                    <Select
                      value={configVisitorType.access_level_id}
                      options={paxtonResources.access_levels?.map(
                        (accessLevel) => ({
                          value: accessLevel.id,
                          label: accessLevel.name,
                        }),
                      )}
                      onChange={(value) =>
                        onVisitorTypeChange(
                          configVisitorType.visitor_type_id,
                          "access_level_id",
                          value,
                        )
                      }
                    />
                  </td>

                  <td>
                    <StyledAltIconButton
                      onClick={() =>
                        onVisitorTypeDelete(configVisitorType.visitor_type_id)
                      }
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </StyledAltIconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </StyledTableWrapper>
      </OverlayLoader>
    </StyledDataTableWrapper>
  );
}

export default PaxtonVisitorTypesView;
